module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden"
  }, [_c('div', {
    ref: "loginBox",
    attrs: {
      "id": "login-box"
    }
  }, [_c('form', [_c('label', {
    attrs: {
      "for": "login-username"
    }
  }, [_vm._v("Email: ")]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticStyle: {
      "color": "red",
      "padding-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "id": "login-username",
      "type": "text",
      "name": "login_username"
    },
    domProps: {
      "value": _vm._s(_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("Password:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "id": "login-password",
      "type": "password",
      "name": "login_password"
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-block"
  }, [_c('span', [_c('input', {
    staticClass: "big-btn grey",
    attrs: {
      "id": "login-submit",
      "type": "submit",
      "name": "submit",
      "value": "Login"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "lostpass",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reset($event)
      }
    }
  }, [_vm._v("Forgot password?")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5663d85f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 502
// module chunks = 1